import {Component, Input, OnInit} from '@angular/core';
import {DevService} from "../dev.service";
import {Router, ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-dev',
  templateUrl: './dev.component.html',
})
export class DevComponent implements OnInit {

  dataset_ids = [];
  dataset_sources = [];
  metadata_by_source_id = [];

  constructor(private devService: DevService,
              private route: ActivatedRoute,
              private router:Router, ) {

      this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
  }

  ngOnInit() {

    // this.devService.getMetadata().then(function(response) {
    //   debugger;
    // })
    // .catch(error => {
    //   console.error(error);
    //   return error;
    // });
  }

}
